import React from 'react';
import { useDraggable } from '@dnd-kit/core';

const DraggableItem = ({ type, label, icon }) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: `toolbox-${type}`,
    data: { type: 'toolbox-item', toolType: type }
  });

  const style = transform ? {
    transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
    zIndex: 1000,
  } : undefined;

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      className={`flex flex-col items-center justify-center p-5 rounded-[2rem] border border-white/5 bg-white/5 hover:border-[#8B3DFF]/50 hover:bg-white/10 hover:shadow-[0_20px_40px_rgba(0,0,0,0.3)] hover:-translate-y-1 transition-all duration-300 cursor-grab active:cursor-grabbing group ${isDragging ? 'opacity-50 ring-2 ring-[#8B3DFF]' : ''}`}
    >
      <div className="text-slate-500 group-hover:text-white transition-all duration-300 mb-3 bg-black/20 group-hover:bg-[#8B3DFF] p-3 rounded-2xl border border-white/5 group-hover:border-[#8B3DFF]/50 shadow-inner">
        {React.cloneElement(icon, { className: "w-6 h-6" })}
      </div>
      <span className="text-[10px] font-black uppercase text-slate-500 tracking-[0.15em] group-hover:text-slate-200 transition-colors">{label}</span>
    </div>
  );
};

const Toolbox = () => {
  const tools = [
    { type: 'row', label: 'Row', icon: <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M4 6h16M4 12h16M4 18h16" /></svg> },
    { type: 'heading', label: 'Heading', icon: <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M3 5h12M9 5v14m0 0H7m2 0h2" /></svg> },
    { type: 'text', label: 'Text', icon: <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M4 6h16M4 12h16m-7 6h7" /></svg> },
    { type: 'image', label: 'Image', icon: <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg> },
    { type: 'button', label: 'Button', icon: <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5" /></svg> },
    { type: 'divider', label: 'Divider', icon: <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M20 12H4" /></svg> },
    { type: 'social', label: 'Social', icon: <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" /></svg> },
  ];

  return (
    <div className="p-4">
      <h3 className="text-[10px] font-black text-white/20 uppercase tracking-[0.3em] mb-6 px-4">Workspace Elements</h3>
      <div className="grid grid-cols-2 gap-4">
        {tools.map((tool) => (
          <DraggableItem key={tool.type} {...tool} />
        ))}
      </div>
    </div>
  );
};

export default Toolbox;
